// redux/actions/notificationAction.ts
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";

export const showNotification = (content: string, severity: "success" | "error" | "warning" | "info" = "info", countDown?: number) => ({
  type: SHOW_NOTIFICATION,
  payload: { content, severity, countDown },
});

export const closeNotification = () => ({
  type: CLOSE_NOTIFICATION,
});
